export default __webpack_public_path__ + "static/media/External.2fc9958f.svg";